import { Float32BufferAttribute } from 'three';
import _ from 'underscore';

import { CesiumPnts } from '../../../../../loader/cesium/content/pnts/types';

/**
 *  Appends the point size as a vertex attribute.
 *
 * @param pntsData - The point cloud chunks data.
 * @param pointSize - The point size to append to the vertex data.
 */
export const PointSizeAttribute = (pntsData: CesiumPnts, pointSize: number) => {
  const pointsCount = pntsData.features.featureTable.POINTS_LENGTH;
  return new Float32BufferAttribute(
    new Float32Array(_.times(pointsCount, () => pointSize)),
    1,
    true,
  );
};
